import { render, staticRenderFns } from "./Question_E.vue?vue&type=template&id=28c95377&scoped=true"
import script from "./Question_E.vue?vue&type=script&lang=js"
export * from "./Question_E.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c95377",
  null
  
)

export default component.exports